const isBlocked = async function () {
  let response = await fetch(`https://api.db-ip.com/v2/free/self`)
  let data = await response.json()
  let ipAddress = await data.ipAddress
  let isBlocked = isBanned(ipAddress)
  return isBlocked
}

function isBanned (ipAddress) {
  var allowedIpPatterns = [
    '208.72.125.2',
    '142.205.*.*',
    '10.235.117.*',
    '10.235.119.*',
    '65.196.66.*',
    '99.250.218.206'
  ]
  if (typeof (ipAddress) === 'string') {
    for (var i = 0; i < allowedIpPatterns.length; i++) {
      if (matches(ipAddress, allowedIpPatterns[i])) {
        return false
      }
    }
  } else {
    return true
  }

  return true
}

function matches (ipAddress, pattern) {
  const ipOctets = ipAddress.split('.')
  const patternOctets = pattern.split('.')
  if (ipOctets.length !== 4 || patternOctets.length !== 4) {
    return false
  }

  for (var i = 0; i < 4; i++) {
    if (patternOctets[i] !== '*' && patternOctets[i] !== ipOctets[i]) {
      return false
    }
  }

  return true
}

export default isBlocked
